import React from 'react';
import { StyledParagraph, StyledSpan } from '../../styles/generic/globalStyledComponents';
import CloudflareImage from '../../components/cloudflare-image/CloudflareImage';
import indexTranslations from '../../i18n/translations/pages/index.json';
import { t } from '../../i18n/i18n';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import LangButton from '../../i18n/LangButton';

import Check from '../../images/icons/check.webp';
import EmailValidationInactive from '../../images/homepage/email-validation-inactive-home.png';
import EmailValidationActive from '../../images/icons/check-shape-lg-base.inline.webp';
import EmailValidationImage from '../../images/homepage/email-validation-homepage.png';
import EmailFinderInactive from '../../images/homepage/email-finder-inactive-home.png';
import EmailFinderActive from '../../images/homepage/email-finder-active.png';
import EmailFinderImage from '../../images/homepage/email-finder-homepage.png';
import ActivityDataInactive from '../../images/homepage/activity-data-inactive-home.png';
import ActivityDataActive from '../../images/homepage/activity-data-active.png';
import ActivityDataImage from '../../images/homepage/activity-data-homepage.png';
import ScoringInactive from '../../images/homepage/email-score-inactive-home.png';
import ScoringActive from '../../images/homepage/email-score-active.png';
import ScoringImage from '../../images/homepage/email-scoring-homepage.png';
import TestingInactive from '../../images/homepage/email-testing-inactive-home.png';
import TestingActive from '../../images/homepage/email-testing-active.png';
import TestingImage from '../../images/homepage/email-testing-homepage.png';
import BlacklistInactive from '../../images/homepage/blacklist-inactive-home.png';
import BlacklistActive from '../../images/homepage/blacklist-active.png';
import BlacklistImage from '../../images/homepage/blacklist-homepage.png';
import DmarcInactive from '../../images/homepage/dmarc-inactive-home.png';
import DmarcActive from '../../images/homepage/dmarc-active.png';
import DmarcImage from '../../images/homepage/dmarc-homepage.png';
import warmupInactive from '../../images/email-deliverability-tools/warmupInactive.png';
import warmupActive from '../../images/email-deliverability-tools/warmupActive.png';
import EmailWarmupImage from '../../images/email-warmup/email_warmup_intro.png';

export const content = () => {
  useI18nInitNamespace('index', indexTranslations, true);
  return {
    email_validation: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_validation_1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('email_validation_li_1')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('email_validation_li_2')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('email_validation_li_3')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('email_validation_li_4')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('email_validation_li_5')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_validation_2')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/email-validation/" externalLink={true}>
          {t('email_validation_button')}
        </LangButton>
      </React.Fragment>
    ),
    activity_data: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('activity_data_1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('activity_data_2')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('activity_data_3')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/activity-data/" externalLink={true}>
          {t('activity_data_button')}
        </LangButton>
      </React.Fragment>
    ),
    email_scoring: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_scoring_1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_scoring_2')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_scoring_3')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/email-scoring/" externalLink={true}>
          {t('email_scoring_button')}
        </LangButton>
      </React.Fragment>
    ),
    dmarc_monitor: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('dmarc_1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('dmarc_2')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('dmarc_3')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('dmarc_li_1')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('dmarc_li_2')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('dmarc_li_3')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('dmarc_li_4')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('dmarc_4')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/dmarc-monitor/" externalLink={true}>
          {t('dmarc_button')}
        </LangButton>
      </React.Fragment>
    ),
    blaclist_monitor: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('blacklist_1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('blacklist_2')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('blacklist_3')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('blacklist_li_1')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('blacklist_li_2')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('blacklist_li_3')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('blacklist_4')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/blacklist-monitoring/" externalLink={true}>
          {t('blacklist_button')}
        </LangButton>
      </React.Fragment>
    ),
    testing_tools: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('testing_tools_1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('testing_tools_li_1')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0">
          <CloudflareImage src={Check} alt="" width="17" height="12" />
          <StyledSpan color="#606E7B" data-margin="0 0 0 5px" fontWeight="400" fontSize="15px">
            {t('testing_tools_li_2')}
          </StyledSpan>
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('testing_tools_2')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/email-server-test/" externalLink={true}>
          {t('testing_tools_button')}
        </LangButton>
      </React.Fragment>
    ),
    email_finder: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_finder_1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_finder_2')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('email_finder_3')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/email-finder/" externalLink={true}>
          {t('email_finder_button')}
        </LangButton>
      </React.Fragment>
    ),
    email_warmup: (
      <React.Fragment>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('tab_6_p1')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('tab_6_p2')}
        </StyledParagraph>
        <StyledParagraph data-margin="10px 0" color="#606E7B" margin="10px 0" fontWeight="400">
          {t('tab_6_p3')}
        </StyledParagraph>
        <LangButton modifier="btn--primary intro__btn-homepage" to="/services/email-warmup/" externalLink={false}>
          {t('tab_6_cta')}
        </LangButton>
      </React.Fragment>
    ),
  };
};

export const tabsQuestions = () => {
  useI18nInitNamespace('index', indexTranslations, true);
  return [
    {
      id: 'email_validation',
      title: t('email_validation_tab'),
      additionalContent: content().email_validation,
      inactiveIcon: EmailValidationInactive,
      activeIcon: EmailValidationActive,
    },
    {
      id: 'activity_data',
      title: t('activity_data_tab'),
      additionalContent: content().activity_data,
      inactiveIcon: ActivityDataInactive,
      activeIcon: ActivityDataActive,
    },
    {
      id: 'email_scoring',
      title: t('email_scoring_tab'),
      additionalContent: content().email_scoring,
      inactiveIcon: ScoringInactive,
      activeIcon: ScoringActive,
    },
    {
      id: 'dmarc_monitor',
      title: t('dmarc_tab'),
      additionalContent: content().dmarc_monitor,
      inactiveIcon: DmarcInactive,
      activeIcon: DmarcActive,
    },
    {
      id: 'blacklist_monitor',
      title: t('blacklist_tab'),
      additionalContent: content().blaclist_monitor,
      inactiveIcon: BlacklistInactive,
      activeIcon: BlacklistActive,
    },
    {
      id: 'testing_tools',
      title: t('testing_tools_tab'),
      additionalContent: content().testing_tools,
      inactiveIcon: TestingInactive,
      activeIcon: TestingActive,
    },
    {
      id: 'email_finder',
      title: t('email_finder_tab'),
      additionalContent: content().email_finder,
      inactiveIcon: EmailFinderInactive,
      activeIcon: EmailFinderActive,
    },
    {
      id: 'email_warmup',
      title: t('email_warmup'),
      additionalContent: content().email_warmup,
      inactiveIcon: warmupInactive,
      activeIcon: warmupActive,
    },
  ];
};

export const tabs = () => {
  useI18nInitNamespace('index', indexTranslations, true);
  return [
    {
      tabID: 'email_validation',
      tabTitle: t('email_validation_tab'),
      tabDescTitle: t('email_validation_title'),
      additionalContent: content().email_validation,
      tabImg: {
        img: EmailValidationImage,
        alt: t('email_validation_alt'),
        width: 320,
        height: 433,
      },
      inactiveIcon: EmailValidationInactive,
      activeIcon: EmailValidationActive,
    },
    {
      tabID: 'activity_data',
      tabTitle: t('activity_data_tab'),
      tabDescTitle: t('activity_data_title'),
      additionalContent: content().activity_data,
      tabImg: {
        img: ActivityDataImage,
        alt: t('activity_data_alt'),
        width: 320,
        height: 433,
      },
      inactiveIcon: ActivityDataInactive,
      activeIcon: ActivityDataActive,
    },
    {
      tabID: 'email_scoring',
      tabTitle: t('email_scoring_tab'),
      tabDescTitle: t('email_scoring_title'),
      additionalContent: content().email_scoring,
      tabImg: {
        img: ScoringImage,
        alt: t('email_scoring_alt'),
        width: 320,
        height: 433,
      },
      inactiveIcon: ScoringInactive,
      activeIcon: ScoringActive,
    },
    {
      tabID: 'dmarc_monitor',
      tabTitle: t('dmarc_tab'),
      tabDescTitle: t('dmarc_title'),
      additionalContent: content().dmarc_monitor,
      tabImg: {
        img: DmarcImage,
        alt: t('dmarc_alt'),
        width: 322,
        height: 546,
      },
      inactiveIcon: DmarcInactive,
      activeIcon: DmarcActive,
    },
    {
      tabID: 'blacklist_monitor',
      tabTitle: t('blacklist_tab'),
      tabDescTitle: t('blacklist_title'),
      additionalContent: content().blaclist_monitor,
      tabImg: {
        img: BlacklistImage,
        alt: t('blacklist_alt'),
        width: 322,
        height: 546,
      },
      inactiveIcon: BlacklistInactive,
      activeIcon: BlacklistActive,
    },
    {
      tabID: 'testing_tools',
      tabTitle: t('testing_tools_tab'),
      tabDescTitle: t('testing_tools_title'),
      additionalContent: content().testing_tools,
      tabImg: {
        img: TestingImage,
        alt: t('testing_tools_alt'),
        width: 320,
        height: 433,
      },
      inactiveIcon: TestingInactive,
      activeIcon: TestingActive,
    },
    {
      tabID: 'email_finder',
      tabTitle: t('email_finder_tab'),
      tabDescTitle: t('email_finder_title'),
      additionalContent: content().email_finder,
      tabImg: {
        img: EmailFinderImage,
        alt: t('email_finder_alt'),
        width: 320,
        height: 433,
      },
      inactiveIcon: EmailFinderInactive,
      activeIcon: EmailFinderActive,
    },
    {
      tabID: 'email_warmup',
      tabTitle: t('email_warmup'),
      tabDescTitle: t('tab_6_h3'),
      additionalContent: content().email_warmup,
      tabImg: {
        img: EmailWarmupImage,
        alt: t('tab_6_alt'),
        width: 370,
        height: 567,
      },
      inactiveIcon: warmupInactive,
      activeIcon: warmupActive,
    },
  ];
};
